import { TbRobot } from 'react-icons/tb'
import { P } from '~/components-v2'
import {
  CompareGrid,
  CompareItem,
  CompareQuote,
  ComparisonCard,
  OmniLogo,
  StrategyLogo,
} from '~/components-v2/compete-comparison-card'

export const CompareCard3 = () => {
  return (
    <ComparisonCard
      className="icon-pink"
      icon={<TbRobot />}
      title="Ask AI twice. Get the same governed answer each time."
      subhead="The same Omni agent works wherever you do: exploring a dashboard, building a query, or editing the model itself. Answers are steered by the same governed context no matter which surface you ask from. Strategy's standard bots read a cube instead: a copy of your data, frozen until the next refresh."
    >
      <CompareGrid
        id="omni-ai"
        compareLogos={[<OmniLogo key={1} />, <StrategyLogo key={2} />]}
        compareItems={[
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>AI is built in, on your terms.</strong>{' '}
                <a
                  href="https://docs.omni.co/ai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Omni’s AI
                </a>{' '}
                runs on every surface of the platform, and admins choose which
                users and groups get it. No extra setup required.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>
                  Strategy AI is only available in cloud infrastructure.
                </strong>{' '}
                Strategy’s legacy platform offers zero AI capabilities,
                cornering users into a cloud migration just to access modern
                features.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Controls to optimize AI for your environment.</strong>{' '}
                Choose the model provider that fits your security and cost
                requirements, and{' '}
                <a
                  href="https://docs.omni.co/ai/settings/usage"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  manage AI spend
                </a>{' '}
                by organization, user, or embedded customer.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>An on/off switch is the whole control panel.</strong>{' '}
                Their AI has no usage caps, per-user budgets, or spending
                limits. Admins can grant it or revoke it, and that’s the extent
                of it.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Package multi-step analysis into one click.</strong>{' '}
                <a href="https://omni.co/blog/introducing-omnis-agent-skills">
                  Agent Skills
                </a>{' '}
                turn repeatable workflows into reusable commands in AI chat,
                routed through your governed Topics. And{' '}
                <a href="https://omni.co/blog/introducing-routines-an-ai-analyst-that-works-in-the-background">
                  Routines
                </a>{' '}
                let AI analysis run on a schedule, or when a condition is met.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>
                  Custom AI agents are gated to the Enterprise tier.
                </strong>{' '}
                Every other plan gets the AI as shipped.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>
                  Guardrails are built into the model and AI harness.
                </strong>{' '}
                Natural language is turned into{' '}
                <a href="https://omni.co/blog/magic-sauce-after-all">
                  semantic queries
                </a>{' '}
                with definitions and permissions enforced. Every answer is
                consistent, governed, and auditable, with fields, filters, and
                SQL available for review.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Their bots see one cube at a time.</strong> Bots are
                built on a single dataset, and cubes are the only supported
                source. The guardrail is also the ceiling.
              </P>
            </CompareItem>,
          ],
          [
            <CompareItem type="positive" key={1}>
              <P>
                <strong>Bring your own AI tools.</strong>{' '}
                <a href="https://omni.co/blog/introducing-omnis-mcp-server">
                  Omni’s MCP Server
                </a>{' '}
                connects{' '}
                <a href="https://omni.co/blog/announcing-openai-app">ChatGPT</a>
                ,{' '}
                <a href="https://omni.co/blog/announcing-claude-connector-and-claude-skills">
                  Claude
                </a>
                , Cursor, and Microsoft Copilot to any governed model under each
                user’s permissions. APIs bring Omni’s AI into your apps, and
                Omni reads context from Notion and writes results back.
              </P>
            </CompareItem>,
            <CompareItem type="negative" key={2}>
              <P>
                <strong>Their MCP endpoint has strings attached.</strong> It
                runs only from their cloud, and only for Mosaic models that have
                been certified.
              </P>
            </CompareItem>,
          ],
          [
            <CompareQuote
              key={1}
              type="positive"
              linkURL="https://omni.co/blog/case-study-bamboohr"
              linkLabel="Omni customer"
              quote={
                <p>
                  Our permissions model is incredibly granular. Most tools
                  couldn’t even come close to supporting it. The Omni team
                  rolled up their sleeves and helped us design something
                  performant and secure.
                </p>
              }
            />,
            <CompareQuote
              key={2}
              type="warn"
              linkURL="https://www.g2.com/survey_responses/strategy-one-formerly-microstrategy-one-review-12401930"
              linkLabel="Strategy customer"
              quote={
                <p>
                  In my case, our company has a lot of objects, and using them
                  when creating agents is more difficult.
                </p>
              }
            />,
          ],
        ]}
      />
    </ComparisonCard>
  )
}
